(function () {
  function isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0") return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getActiveBannerVideo(bannerEl) {
    const videos = bannerEl.querySelectorAll("video.js-video");
    // Prefer the visible one (mobile vs desktop)
    for (const v of videos) if (isVisible(v)) return v;
    return videos[0] || null;
  }

  function ensurePlayButton(bannerEl) {
    let btn = bannerEl.querySelector(".hero-video__play");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "hero-video__play";
      btn.setAttribute("aria-label", "Play video");
      bannerEl.appendChild(btn);
    }
    return btn;
  }

  async function tryPlay(video, bannerEl, fromUserGesture) {
    if (!video) return;

    // iOS-friendly defaults
    video.muted = true;
    video.setAttribute("muted", "muted");
    video.setAttribute("playsinline", "playsinline");
    video.setAttribute("webkit-playsinline", "webkit-playsinline");

    try {
      const p = video.play();
      if (p && typeof p.then === "function") await p;
      bannerEl.classList.remove("is-video-blocked");
      bannerEl.classList.remove("is-video-failed");
    } catch (e) {
      // Autoplay or policy block (common). If this was NOT a user gesture, show the button.
      bannerEl.classList.add("is-video-blocked");
      if (fromUserGesture) {
        // If even a user gesture fails, treat as real failure (codec/source/etc)
        bannerEl.classList.add("is-video-failed");
        // Keep poster visible; optionally hide video layer if you want:
        // video.style.display = "none";
      }
    }
  }

  function init() {
    // Target your hero banner(s). Adjust selector if needed.
    const banners = document.querySelectorAll(".js-general-banner");
    banners.forEach((bannerEl) => {
      const video = getActiveBannerVideo(bannerEl);
      if (!video) return;

      const btn = ensurePlayButton(bannerEl);

      // Attempt autoplay when possible
      // (Do NOT wrap in setTimeout; keep it immediate after load)
      const attempt = () => tryPlay(video, bannerEl, false);
      if (video.readyState >= 2) {
        attempt();
      } else {
        video.addEventListener("canplay", attempt, { once: true });
      }

      // Guaranteed user-gesture play
      const onUserPlay = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        tryPlay(video, bannerEl, true);
      };
      btn.addEventListener("click", onUserPlay, { passive: false });
      btn.addEventListener("touchend", onUserPlay, { passive: false });

      // If iOS shows the native play overlay, also let taps on the media wrapper trigger play
      const mediaWrap = bannerEl.querySelector(".general-banner__media-wrapper");
      if (mediaWrap) {
        mediaWrap.addEventListener("click", onUserPlay, { passive: false });
        mediaWrap.addEventListener("touchend", onUserPlay, { passive: false });
      }

      // Log hard failures (useful while debugging)
      video.addEventListener("error", () => {
        bannerEl.classList.add("is-video-failed");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


(function () {
  const SELECTOR = ".js-video video.js-video, video.js-video"; // handle either pattern

  function isActuallyVisible(el) {
    if (!el || !el.isConnected) return false;
    const style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") return false;

    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth);
  }

  async function tryPlay(video) {
    try {
      // iOS is picky: set properties AND attributes.
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");
      video.setAttribute("autoplay", "");

      const p = video.play();
      if (p && typeof p.then === "function") await p;
      video.dataset.autoplaySucceeded = "true";
      return true;
    } catch (e) {
      video.dataset.autoplaySucceeded = "false";
      // Let your existing “tap to play” UI remain
      return false;
    }
  }

  function setup() {
    const videos = Array.from(document.querySelectorAll("video.js-video"));

    if (!videos.length) return;

    // Only try autoplay when the element is in view (matches WebKit policy)
    const io = new IntersectionObserver(async (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const v = entry.target;
        if (!isActuallyVisible(v)) continue;
        if (v.dataset.autoplayAttempted === "true") continue;

        v.dataset.autoplayAttempted = "true";
        await tryPlay(v);
      }
    }, { threshold: 0.25 });

    videos.forEach(v => {
      // Only bother if autoplay is present (or you want to force attempt anyway)
      if (v.hasAttribute("autoplay")) io.observe(v);
    });

    // Optional: if the first attempt fails, one “first user gesture” retry can help.
    // This does NOT create “true autoplay”, but it makes the experience feel instant.
    const onceGestureRetry = async () => {
      document.removeEventListener("touchend", onceGestureRetry, true);
      for (const v of videos) {
        if (v.dataset.autoplaySucceeded === "true") continue;
        if (!isActuallyVisible(v)) continue;
        await tryPlay(v);
      }
    };
    document.addEventListener("touchend", onceGestureRetry, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
  } else {
    setup();
  }
})();
